import { NotifyHelper } from "../../../helpers/toast";
import { generateActionForKey, generateActions } from "../generateActions";
import { objTrangThaiHocSinhDefine } from "../../action-types/trang-thai-hoc-sinh/ITrangThaiHocSinhActionTypes";

export const trangThaiHocSinhAction = {
    ...generateActions(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH"),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "LOAD_CHECKDANGKY_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "LOAD_CHECKDANGKY_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "LOAD_COSO_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "LOAD_COSO_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "INSERT_MULTIPLE_SUCCESS", (m: any) => NotifyHelper.Success("Inserted multiple items")),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "INSERT_MULTIPLE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "UPDATE_SUCCESS", (m: any) => NotifyHelper.Success("Updated")),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "UPDATE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "UPDATE_THU_TU_SUCCESS", (m: any) => NotifyHelper.Success("Order updated")),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "UPDATE_THU_TU_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "DELETE_SUCCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objTrangThaiHocSinhDefine, "TRANG_THAI_HOC_SINH",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}